//Function to validate email address

export default function maskData(type, value) {
    if(type == 'SSN') {
        let SSN_Number = value.slice(7,11);
        let Mask_SSN  = `XXX-XX-${SSN_Number}`;
        return Mask_SSN
    } else {
        let Mask_Aln = ''
        if(value == 9){
            Mask_Aln  = "Axxxx" + value.substr(value.length - 4);
          }else{
            Mask_Aln  = "Axxxxx" + value.substr(value.length - 4);
          }
        return Mask_Aln
    }
  }
  
  